$(window).scroll(function(){
    if ($(window).scrollTop() >= 100) {
        $('.announcement-bar').addClass('fixed-header');
        $('#HeaderWrapper').addClass('fixed-header');
    }
    else {
        $('.announcement-bar').removeClass('fixed-header');
        $('#HeaderWrapper').removeClass('fixed-header');
    }
});

$(".addtocart-button").click(function () {
  $(this).parents(".product-grid-item").find(".quick-add-btn").trigger('click');
  $(this).addClass("active");

  setTimeout(() => {
    $(this).removeClass("active");
  }, 2000);
});



$('.all-variants').change(function(){   
  var optionSelected = $("option:selected", this).data("variantid");
  var optionImage = $("option:selected", this).attr("image");
  var productComparePrice = $("option:selected", this).attr("compare_at_price");
  var productPrice = $("option:selected", this).attr("price");
  var productDiscount = $("option:selected", this).data("discount");
  $(this).parents(".product-grid-item").find(".quick-add-btn").attr("data-id", optionSelected);
  $(this).parents(".product-grid-item").find(".grid__image-ratio img").attr("srcset", optionImage);
  $(this).parents(".pricesection-gridsection").find(".compare-price").text(productComparePrice);
  $(this).parents(".pricesection-gridsection").find(".main-price").text(productPrice);
  $(this).parents(".pricesection-gridsection").find(".save-money").text(productDiscount);

});

$(".buttonclose svg").click(function(){
  $("toggle-menu button").trigger("click");
})

$("h2.main-close-cart").click(function(){
  $("close-cart button").trigger("click");
})

function formatToINR(amount) {
    let formattedAmount = (amount / 100).toFixed(2); // Convert to decimal format
    return "Rs. " + formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add comma separators
}

document.addEventListener('ajaxProduct:added', function(evt) {
   $('#add-to-bag-message')
    .addClass('show')
    .fadeIn(200);

  setTimeout(function () {
    $('#add-to-bag-message')
      .fadeOut(400, function () {
        $(this).removeClass('show');
      });
  }, 2000);
  var compare_price_discount=0;
  $.getJSON('/cart', function(response) {
    console.log("response", response.item_count);
    var countitem = response.item_count;
    $(".cart-link__bubble-num").text(response.item_count);
    if(countitem <= 0){
      $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
    }else{
      $(".cart-link__bubble").addClass("cart-link__bubble--visible");
    }
  const itemRequests = response.items.map(item => {
    return $.getJSON(window.location.origin + item.url).then(productResponse => {
      const variant = productResponse.product.variants.find(v => v.id === item.variant_id);
      if (variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        compare_price_discount += item.quantity * (Number(variant.compare_at_price) - Number(variant.price));
      }
    });
  });

  Promise.all(itemRequests).then(() => {
    const totalSavings = response.total_discount + compare_price_discount * 100; // adjust *100 if prices are already in cents
    const newSubtotal = response.original_total_price + compare_price_discount * 100;
    var subtotalAmount = response.original_total_price + compare_price_discount * 100;
    var totalValue = response.original_total_price;
    $('.cart__item-sub .subtotal').text(formatINR(subtotalAmount));
    $('#cartTotalPrice').text(formatINR(totalValue)); 
    if ($('#cart_drawer .discount_price')) {
      var savingAmount = response.total_discount + compare_price_discount*100; 
      $('.cart__item-sub .savings').text(formatINR(savingAmount));
      if (parseInt(totalSavings) > 0) {
        $('.marquee p').text('You are saving ' + formatINR(savingAmount) + ' on this order.');
      } else {
        $('.marquee p').text('Free Shipping above Rs.1,000');
      }
    }

    
  });
});
});

document.addEventListener('cart:updated', function(evt) {
   var compare_price_discount=0; 
  $.getJSON('/cart', function(response) { 
    var countitem = response.item_count;
    $(".cart-link__bubble-num").text(response.item_count);
    if(countitem <= 0){
      $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
    }else{
      $(".cart-link__bubble").addClass("cart-link__bubble--visible");
    }
  const itemRequests = response.items.map(item => {
    return $.getJSON(window.location.origin + item.url).then(productResponse => {
      const variant = productResponse.product.variants.find(v => v.id === item.variant_id);
      if (variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        compare_price_discount += item.quantity * (Number(variant.compare_at_price) - Number(variant.price));
      }
    });
  });

  Promise.all(itemRequests).then(() => {
    const totalSavings = response.total_discount + compare_price_discount * 100; // adjust *100 if prices are already in cents
    const newSubtotal = response.original_total_price + compare_price_discount * 100;
    var subtotalAmount = response.original_total_price + compare_price_discount * 100;
    var totalValue = response.original_total_price;
    $('.cart__item-sub .subtotal').text(formatINR(subtotalAmount));
    $('#cartTotalPrice').text(formatINR(totalValue));
    if ($('#cart_drawer .discount_price')) {
      var savingAmount = response.total_discount + compare_price_discount*100; 
      $('.cart__item-sub .savings').text(formatINR(savingAmount));
      if (parseInt(totalSavings) > 0) {
        $('.marquee p').text('You are saving ' + formatINR(savingAmount) + ' on this order.');
      } else {
        $('.marquee p').text('Free Shipping above Rs.1,000');
      }
    }

    
  });
});
    
const totalPrice =   evt.detail.cart.total_price;
if(totalPrice == 0){
  //alert("Hello");
  $(".site-header__drawer").removeClass("is-active");
  $("header-section").removeClass("cart-open");
  $("body").removeAttr("style");
}
  
});

 

$('body').on('click', '.removebutton',function(e){ 
    var id = $(this).data("variant-id");
    $(`.section-${id}`).remove();
})



let uspPopup = (blockid) => {
  let popupSelect = document.querySelector(`.tags[data-usp="${blockid}"]`)
  popupSelect.style.display = "flex"
}

 $('.tags strong').click(function(){
    $('.tags').hide()
  })

 
  $(document).ready(function () {
    var breadcrumbHTML = $('.product-single__meta .breadcrumb').prop('outerHTML');
    var mainTitle = $('.product-single__meta .product-single__title').prop('outerHTML');
    var vendorSku = $('.product-single__meta .product-single__vendor-sku').prop('outerHTML');
    var deliveryText = $('.product-single__meta #delivery-status').prop('outerHTML');
    var returnText = $('.product-single__meta #return-status').prop('outerHTML');
    var inventoryText = $('.product-single__meta .product-inventory__points').prop('outerHTML');
    var mainPrice = $('.product-single__meta .block-price.product-block').prop('outerHTML'); 

     $('.sc-configurator').prepend('<div class="desktoponly-section">' + breadcrumbHTML + mainTitle + vendorSku + mainPrice +'</div>');
     $('.sc-card-options').append('<div class="iconsection-text">' + deliveryText + returnText + inventoryText + '</div>');

    $(".sc-card-option__value").click(function(){
       var priceText = $(".sc-gift-card__value span").text();
      $(".block-price__regular.product__price").text(priceText);
    })

    $(".sc-card-option__value input").change(function(){
       var priceText = $(".sc-gift-card__value span").text();
      $(".block-price__regular.product__price").text(priceText);
    })
    
  });


if($('.custom-giftreggie-btn').length > 0) {
   $('.giftreggie-pdp-button-area').show()
 }
 else {
   $('.giftreggie-pdp-button-area').hide()
 }

 
$(document).ready(function(){
    let htmlContent = $('.pdp-offersection').html(); 
    $('.mobileview-section').append(htmlContent);
  });

$(document).ready(function() {
  // if ($(window).width() < 767) {
  //   $(".coppun-btn").on("click", function() {
  //   // alert("Hello");
  //   window.location.href = 'https://allthingsbaby-website.onelink.me/U5xy/m49v36bn';
  //   });
  // } else {
  //   $(".coppun-btn").on("click", function() {
  //   $(".custom-model-main").addClass("model-open");
  //   });
  // }

  $(".coppun-btn").on("click", function() {
    //debugger;
    var copytxt = $(".coppun-btn b").text().trim();
    var $this = $(this);
    navigator.clipboard.writeText(copytxt).then(function () {

    // Remove old tooltip if exists
    $this.find(".copy-tooltip").remove();

    // Add tooltip
    $this.append('<span class="copy-tooltip">Copied!</span>');

    // Hide after 2 sec
    setTimeout(function () {
      $this.find(".copy-tooltip").fadeOut(300, function () {
        $(this).remove();
      });
    }, 2000);

  });
  });
}); 

// Update pricing
let compare_price_discount = 0;
function formatINR(paise) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(paise / 100);
}
$.getJSON('/cart', function(response) {
  const itemRequests = response.items.map(item => {
    return $.getJSON(window.location.origin + item.url).then(productResponse => {
      const variant = productResponse.product.variants.find(v => v.id === item.variant_id);
      if (variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        compare_price_discount += item.quantity * (Number(variant.compare_at_price) - Number(variant.price));
      }
    });
  });

  Promise.all(itemRequests).then(() => {
    const totalSavings = response.total_discount + compare_price_discount * 100; // adjust *100 if prices are already in cents
    const newSubtotal = response.original_total_price + compare_price_discount * 100;
    var subtotalAmount = response.original_total_price + compare_price_discount * 100;
    $('.cart__item-sub .subtotal').text(formatINR(subtotalAmount));
    if ($('#cart_drawer .discount_price')) {
      var savingAmount = response.total_discount + compare_price_discount*100; 
      $('.cart__item-sub .savings').text(formatINR(savingAmount));
      if (parseInt(totalSavings) > 0) {
        $('.marquee p').text('You are saving ' + formatINR(savingAmount) + ' on this order.');
      } else {
        $('.marquee p').text('Free Shipping above Rs.1,000');
      }
    }

    
  });
});


$(".add-item").click(function(){
  $(".main-close-cart").trigger("click");
})

// Clertap Navigation Code
$(document).ready(function() {

  //For mobile menu
  $('.slide-nav__item a.slide-nav__link').each(function() {
    
    $(this).on('click', function(event) {
      event.preventDefault();

      var url = this.href;
      var name = this.textContent.trim(); // Get the text content of the link

      if(name == 'View all'){
        var mainCategory = $(this).parent().parent().children()[0];
        var categoryName = $(mainCategory).children().text().trim(); //= $(this).parent().parent().children()[0];
        name = 'View all - ' + categoryName;
      }

       clevertap.event.push("Menu clicked", {
        "Menu name":name,
        "url":url
      });

      window.location.href = url;
    });
  });

//For desktop main menu
$('.site-nav__item summary.site-nav__link').each(function() {
  
  $(this).on('click', function(event) {
    event.preventDefault();

    var url = $(this).data("link");
    var name = this.textContent.trim(); // Get the text content of the link

    if(name == 'View all'){
      var mainCategory = $(this).parent().parent().children()[0];
      var categoryName = $(mainCategory).children().text().trim(); //= $(this).parent().parent().children()[0];
      name = 'View all - ' + categoryName;
    }
    
     clevertap.event.push("Menu clicked", {
      "Menu name":name,
      "url":url
    });

    window.location.href = url;
  });
});

$('.site-nav__item a.site-nav__link').each(function() {
  
  $(this).on('click', function(event) {
    event.preventDefault();

    var url = this.href;
    var name = this.textContent.trim(); // Get the text content of the link

    if(name == 'View all'){
      var mainCategory = $(this).parent().parent().children()[0];
      var categoryName = $(mainCategory).children().text().trim(); //= $(this).parent().parent().children()[0];
      name = 'View all - ' + categoryName;
    }
    
     clevertap.event.push("Menu clicked", {
      "Menu name":name,
      "url":url
    });

    window.location.href = url;
  });
});  

//For desktop megamenu inner sub menu
$('.site-nav__dropdown-link').each(function() {
  
  $(this).on('click', function(event) {
    event.preventDefault();

    var url = this.href;
    var name = this.textContent.trim(); // Get the text content of the link

     clevertap.event.push("Menu clicked", {
      "Menu name":name,
      "url":url
    });

    window.location.href = url;
  });
});
});


var shippingtext = $("#delivery-status .np-usp_title").text();

if($(".product-single__meta").hasClass("textchange-ship")){
  $("#delivery-status .np-usp_title").text("Delivery in 7 to 10 days");
}

$(".variant__button-label").click(function(){
  //debugger;
  var preordertag = $("#preorder-sec").val();
  var inventoryStock = $(this).data("stock");
  var variantTag = $(this).data("tag");
  
  if(preordertag == "pre-order"){
    $(".btn.btn--full.add-to-cart").text("Pre-Order");
  }

  if(inventoryStock >= 1 ){
    //alert("Hello");
    $(".product-grid__content").removeClass("grayed_color");
  }else{
    //alert("Hello");
    $(".product-grid__content").addClass("grayed_color");
  }

  if(variantTag == "pre order"){
    $(".pincodesection-pdp").hide();
     $("#delivery-status .np-usp_title").text("Delivery in 7 to 10 days");
    //  setTimeout(function(){ 
    //   $("button.add-to-cart span").text("Pre Order");
    //  },1000)
  }else{ 
    $(".pincodesection-pdp").show();
     $("#delivery-status .np-usp_title").text(shippingtext);
  }



  
});

// setTimeout(function(){
//   $("#HeaderCartTrigger").attr("href", "/cart");
// },3000)

$(".main-close-cart").click(function(){ 
  $(".site-header__cart").removeClass("is-active");
  $("header-section").removeClass("cart-open");
  $("body").removeAttr("style");
   // Hide elements (pure JS)
  const whatsappIcon = document.querySelector("a#whatsapp-chat-icon");
  if (whatsappIcon) whatsappIcon.style.display = "block";

  const nectorWidget = document.querySelector(".nector-websdk-widget");
  if (nectorWidget) nectorWidget.style.display = "block";
})

$("#HeaderCartTrigger").click(function(){ 
  $(".site-header__cart").addClass("is-active");
  $("header-section").addClass("cart-open");
  $("body").attr("style");
  // Hide elements (pure JS)
  const whatsappIcon = document.querySelector("a#whatsapp-chat-icon");
  if (whatsappIcon) whatsappIcon.style.display = "none";

  const nectorWidget = document.querySelector(".nector-websdk-widget");
  if (nectorWidget) nectorWidget.style.display = "none";
})



// Pincode Code

// $(document).ready(function() {

//   // -------------------
//   // Cookie functions
//   // -------------------
//   function setCookie(name, value, days) {
//     var expires = "";
//     if (days) {
//       var date = new Date();
//       date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//       expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + value + expires + "; path=/";
//   }

//   function getCookie(name) {
//     var nameEQ = name + "=";
//     var cookiesArray = document.cookie.split(";");
//     for (var i = 0; i < cookiesArray.length; i++) {
//       var cookie = cookiesArray[i].trim();
//       if (cookie.indexOf(nameEQ) === 0) {
//         return cookie.substring(nameEQ.length, cookie.length);
//       }
//     }
//     return null;
//   } 



// $(".pincodetxt").click(function(){
//   $(".pincodesection-mainsection").css("display", "flex");
// })

// $(".pinclose-btn").click(function(){
//   $(".pincodesection-mainsection").css("display", "none");
// })


//   // For PDP
  
//   // Allow only numeric input
//   $('#pincodeInput').on('input', function() {
//     this.value = this.value.replace(/[^0-9]/g, '');
//   });

//   // Convert date to readable English format
//   function convertToEnglishDate(dateStr) {
//     var parts = dateStr.split('/');
//     var day = parseInt(parts[0]);
//     var month = parseInt(parts[1]) - 1;
//     var year = parseInt(parts[2]);
//     var date = new Date(year, month, day);
//     var options = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' };
//     return `${date.toLocaleDateString("en-GB", options)}`;
//   }

//   // Fetch delivery data via API
// function fetchDeliveryData(destinationPincode) {
//   var currentDate = new Date(); 

//   if ($(".product-single__meta").hasClass("personalised-section")) {
//     const d = new Date();
//     d.setDate(d.getDate() + 10); // today + 10 days

//     const options = { weekday: 'long', day: '2-digit', month: 'long' };
//     let finalDate = d.toLocaleDateString('en-GB', options);
//     finalDate = finalDate.replace(/^(\w+)/, '$1');

//     $('#deliveryDate').text(finalDate);
//     $('#deliveryText').show();
//     $('#pickuptextsec').show();
//     if (destinationPincode) {
//       $(".locationtext").text(destinationPincode);
//       $("#headerpincode").text(destinationPincode);
//     }
//       else {
//       $('#deliveryDate').text("Not available");
//       $('#deliveryText').show();
//       $('#pickuptextsec').hide();
//     }
//   }
//   else{
//     $.ajax({
//       url: `https://cors.eu.org/https://allthingsbaby.in/get_edd.php?origin_pin=400002&destination_pin=${destinationPincode}`,
//       //url: `https://allthingsbaby.in/get_edd.php?origin_pin=400002&destination_pin=${destinationPincode}`,
//       type: "GET",
//       dataType: "json",
//       beforeSend: function () {
//         $('#deliveryText').hide();
//         $('#pickuptextsec').hide();
//         $('#errorMsg').hide();
//         $('#deliveryDate').text("Checking...");
//         $('#deliveryText').show();
//       },
//       success: function (response) { 
//         // Get TAT value
//         const tatval = parseInt(response.data.tat);

//         if (!isNaN(tatval)) {

//           // Add TAT days to today's date
//           let d = new Date();
//           d.setDate(d.getDate() + tatval);

//           // Format: Fri, 21 Nov
//           const options = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' };
//           let finalDate = d.toLocaleDateString('en-GB', options);
//           // ✅ Ensure comma after weekday
//         finalDate = finalDate.replace(/^(\w+)/, '$1');

//           // Update UI
//           $('#deliveryDate').text(finalDate);
//           $('#deliveryText').show();
//           $('#pickuptextsec').show();
//           $(".locationtext").text(destinationPincode);
//           $("#headerpincode").text(destinationPincode);
//         } 
//         else {
//           $('#deliveryDate').text("Not available");
//           $('#deliveryText').show();
//           $('#pickuptextsec').hide();
//         }
//       },
//       error: function () {
//         $('#deliveryDate').text("Failed to fetch details. Try again.");
//         $('#deliveryText').show();
//         $('#pickuptextsec').hide();
//       }
//     });
//   }


// }


// // Validate and check button
// $('#pincodebtn').on('click', function() {
//   var destinationPincode = $('#pincodeInput').val().trim();

//   if (/^\d{6}$/.test(destinationPincode)) {
//     $('#errorMsg').hide();
//     setCookie("userPincode", destinationPincode, 7);
//     fetchDeliveryData(destinationPincode);
//   } else {
//     $('#errorMsg').show();
//     $('#deliveryText').hide();
//     $('#pickuptextsec').hide();
//   }
// });

// // Trigger button click on Enter key
// $('#pincodeInput').on('keypress', function (e) {
//     if (e.which === 13) {  // 13 = Enter key
//         $('#pincodebtn').click();
//     }
// });  

//   // -------------------
//   // Auto-load from cookie
//   // -------------------
//   var savedPincode = getCookie("userPincode");
//   if (savedPincode && /^\d{6}$/.test(savedPincode)) {
//     $('#pincodeInput').val(savedPincode);
//     fetchDeliveryData(savedPincode);
//   }


//   // For Header Pincode

//   // Allow only numeric input
//   $('#pincodeInput').on('input', function() {
//     this.value = this.value.replace(/[^0-9]/g, '');
//   });
 
//   // Fetch delivery data via API
//   function fetchDeliveryData1(destinationPincode) {
//     var currentDate = new Date();

//     $.ajax({
//     url: `https://cors.eu.org/https://allthingsbaby.in/get_edd.php?origin_pin=400002&destination_pin=${destinationPincode}`,
//     //url: `https://allthingsbaby.in/get_edd.php?origin_pin=400002&destination_pin=${destinationPincode}`,
//     type: "GET",
//     dataType: "json",
//     beforeSend: function () {
//       $('#deliveryText1').hide();
//       $('#pickuptextsec1').hide();
//       $('#errorMsg1').hide();
//       $('#deliveryDate1').text("Checking...");
//       $('#deliveryText1').show();
//     },
//     success: function (response) {

//       // Get TAT value
//       const tatval = parseInt(response.data.tat);

//       if (!isNaN(tatval)) {

//         // Add TAT days to today's date
//         let d = new Date();
//         d.setDate(d.getDate() + tatval);

//         // Format: Fri, 21 Nov
//         const options = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' };
//         const finalDate = d.toLocaleDateString('en-GB', options);

//         // Update UI
//         $('#deliveryDate1').text(finalDate);
//         $('#deliveryText1').show();
//         $('#pickuptextsec1').show();
//         $(".locationtext").text(destinationPincode);
//         $("#headerpincode").text(destinationPincode);
//       } 
//       else {
//         $('#deliveryDate1').text("Not available");
//         $('#deliveryText1').show();
//         $('#pickuptextsec1').hide();
//       }
//     },
//     error: function () {
//       $('#deliveryDate1').text("Failed to fetch details. Try again.");
//       $('#deliveryText1').show();
//       $('#pickuptextsec1').hide();
//     }
//   });
//   }

//   // Validate and check button
//   $('#pincodebtn1').on('click', function() {
//     var destinationPincode = $('#pincodeInput1').val().trim();

//     if (/^\d{6}$/.test(destinationPincode)) {
//       $('#errorMsg1').hide();
//       setCookie("userPincode", destinationPincode, 7);
//       fetchDeliveryData1(destinationPincode);
//       setTimeout(function(){
//         $(".pincodesection-mainsection").hide();
//       },500)
      
//     } else {
//       $('#errorMsg1').show();
//       $('#deliveryText1').hide();
//       $('#pickuptextsec1').hide();
//     }
//   });

//   $('#pincodeInput1').on('keypress', function (e) {
//     if (e.which === 13) {  // 13 = Enter key
//         $('#pincodebtn1').click();
//     }
// });

//   // -------------------
//   // Auto-load from cookie
//   // -------------------
//   var savedPincode = getCookie("userPincode");
//   if (savedPincode && /^\d{6}$/.test(savedPincode)) {
//     $('#pincodeInput1').val(savedPincode);
//     fetchDeliveryData1(savedPincode);
//   }
//   if(savedPincode){
//     $("#headerpincode").text(savedPincode)
//     $(".locationtext").text(savedPincode)
//   }

// });


$(".announcement-slider__content em").click(function () {
  var copytxt = $(this).text().trim();
  var $this = $(this);

  navigator.clipboard.writeText(copytxt).then(function () {

    // Remove old tooltip if exists
    $this.find(".copy-tooltip").remove();

    // Add tooltip
    $this.append('<span class="copy-tooltip">Copied!</span>');

    // Hide after 2 sec
    setTimeout(function () {
      $this.find(".copy-tooltip").fadeOut(300, function () {
        $(this).remove();
      });
    }, 2000);

  });
});


// const originPin = "400002";
// const destinationPin = "364001";

// const url = `https://allthingsbaby.in/get_edd.php?origin_pin=${originPin}&destination_pin=${destinationPin}`;

// fetch(url)
//   .then(response => {
//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }
//     return response.json(); // use .text() if response is not JSON
//   })
//   .then(data => {
//     console.log("EDD Response:", data);
//   })
//   .catch(error => {
//     console.error("Error fetching EDD:", error);
//   });



document.addEventListener('variant:change', function(evt) {
  console.log(evt.detail.variant);
});


$(document).on("click", function (e) {
  if (
    $(".site-header__cart").hasClass("is-active") &&
    !$(e.target).closest(".site-header__cart, #HeaderCartTrigger").length
  ) {
    $(".site-header__cart").removeClass("is-active");
    $("header-section").removeClass("cart-open");
    $("body").removeAttr("style");
    $("body").removeAttr("id");
  }
});


if (window.innerWidth > 990) {

  var $slider = $('.customgrid-sliderbox');
  var slideCount = $slider.children().length;

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: slideCount > 4, // ✅ show arrows only if >4
    dots: false,
    infinite: false,
    speed: 600,
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Group_1400003720.png?v=1760338938" alt="image" /></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Group_1400003720.png?v=1760338938" alt="image" /></button>',
  });

}


if (window.innerWidth > 990) {

  var $slider = $('.slidervariant-sec');
  var slideCount = $slider.children().length;

  $slider.slick({
    slidesToShow: 4.3,
    slidesToScroll: 1,
    arrows: slideCount > 4, // ✅ show arrows only if >4
    dots: false,
    infinite: false,
    speed: 600,
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Group_1400003720.png?v=1760338938" alt="image" /></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Group_1400003720.png?v=1760338938" alt="image" /></button>',
  });

}

// Popup Image
$(".popupimage-sectioninner img").click(function(){
  $(".fullscreen-popupsection").removeClass("hidepopup");
  $(".popupimage-section").hide();
})

$(".closebtnsec").click(function(){
  $(".fullscreen-popupsection").addClass("hidepopup");
  $(".popupimage-section").show();
})
$(".fullscreen-popupsection").click(function(){
  $(".fullscreen-popupsection").addClass("hidepopup");
  $(".popupimage-section").show();
})
$(".closebtn").click(function(){
  $(".popupimage-section").hide();
})

let popupImage = sessionStorage.getItem('popupimage');

// Show popup only if not stored
if (!popupImage) {
  setTimeout(function () {
    $(".fullscreen-popupsection").removeClass("hidepopup");
  }, 2000);
}
sessionStorage.setItem('popupimage', 'hide');

// Tabbing Collection
$(".buttonsection-tabing button").click(function(){
  $(".buttonsection-tabing button").removeClass("active");
  $(this).addClass("active");
  const dataValue = $(this).data("value");
  //alert(dataValue);
  $(".gridsection-tabbingcollection").css("display", "none");
  $(`[data-text="${dataValue}"].gridsection-tabbingcollection`).css("display", "flex");
  $(".tabingsection-new a.view-all-link-tw").hide();
  $(`.tabingsection-new [data-value="${dataValue}"].view-all-link-tw`).show();

})

$(".buttonsection-locater button").click(function(){
  var dataText = $(this).data("value");
  $(".buttonsection-locater button").removeClass("active");
  $(this).addClass("active");
  $(".location-contentsection").hide();
  $(".store_innerbanner").hide();
  $(`[data-text="${dataText}"]`).show();
})


$('.variant-tagsec').hide();
$(document).on('change', '.all-variants', function () {
    let selectedVariantId = $(this).find(':selected').data('variantid');
    let parent = $(this).closest('.product-grid-item');
    parent.find('.variant-tagsec').hide();
    parent.find('.variant-tagsec[data-variantid="' + selectedVariantId + '"]').show();
});

$('.all-variants').trigger('change');







$(document).on('click','.notify-btn',function(e){
e.preventDefault();

$('.notify-popup-wrap').fadeIn(200);
});

$(document).on('click','.notify-close',function(){
$('.notify-popup-wrap').fadeOut(200);
});

$(document).on('click','.notify-popup-wrap',function(e){
if($(e.target).hasClass('notify-popup-wrap')){
$('.notify-popup-wrap').fadeOut(200);
}

});




function getNotifyData(){

return{

email:$('.notify-email').val().trim(),

number:$('.notify-phone').val().trim(),

product_url:
currentNotifyData.product_url ||
window.location.href,

product_name:
currentNotifyData.product_name ||
$('.product-single__title,.product__title h1,h1').first().text().trim(),

variant_name:
currentNotifyData.variant_name ||
window.currentVariant?.title ||
'',

variant_id:
currentNotifyData.variant_id ||
window.currentVariant?.id ||
'',

sku:
currentNotifyData.sku ||
window.currentVariant?.sku ||
'',

selling_price:
currentNotifyData.selling_price ||
window.currentVariant?.price ||
'',

compare_price:
currentNotifyData.compare_price ||
window.currentVariant?.compare_price ||
''

};

}

function validateNotify(){

$('.notify-error').text('');
$('.notify-email,.notify-phone')
.removeClass('notify-input-error');

var email=$('.notify-email').val().trim();
var number=$('.notify-phone').val().trim();

var emailRegex=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var phoneRegex=/^[0-9]{10}$/;

var valid=true;

if(!email){

$('.notify-email')
.addClass('notify-input-error');

$('.notify-email-error')
.text('Email is required');

valid=false;

}else if(!emailRegex.test(email)){

$('.notify-email')
.addClass('notify-input-error');

$('.notify-email-error')
.text('Enter valid email');

valid=false;

}

if(!number){

$('.notify-phone')
.addClass('notify-input-error');

$('.notify-phone-error')
.text('Phone is required');

valid=false;

}else if(!phoneRegex.test(number)){

$('.notify-phone')
.addClass('notify-input-error');

$('.notify-phone-error')
.text('Enter valid 10 digit number');

valid=false;

}

return valid;

}

function submitNotify(btn){

if(!validateNotify()) return;

var data=getNotifyData();

console.log(data);

btn.prop('disabled',true);
btn.text('Submitting...');

fetch(
'https://script.google.com/macros/s/AKfycbznJ2XGhGS2uksWyo2NkpHIAWxc9PPLotP5t5DkkckStYH-Mfj4okRu2729B-oQNKAcyQ/exec',
{
method:'POST',
mode:'no-cors',
headers:{
'Content-Type':'text/plain'
},
body:JSON.stringify(data)
}
)

.then(()=>{

btn.text('✓ Submitted');

setTimeout(function(){

$('.notify-popup-wrap').fadeOut();

btn.prop('disabled',false);
btn.text('Submit');

$('.notify-email').val('');
$('.notify-phone').val('');

currentNotifyData={};

},1500);

})

.catch(()=>{

btn.prop('disabled',false);
btn.text('Submit');

alert('Something went wrong');

});

}

$(document).on(
'click',
'.notify-submit',
function(){

submitNotify($(this));

});






var currentNotifyData={};
$(document).on('click','.notify-btn-card',function(e){
e.preventDefault();
e.stopPropagation();
var parent=$(this).closest('.product-grid-item');
var selectedOption=
parent.find('.all-variants option:selected');
currentNotifyData={
product_url:
$(this)
.data('product-url')
.replace(
'https://allthingsbaby.comhttps://allthingsbaby.com',
'https://allthingsbaby.com'
),

product_name:
$(this).data('product-name'),

variant_name:
(
$(this).data('variant-name') || ''
)
.replace(/\/\s*$/,'')
.trim(),

variant_id:
selectedOption.data('variationid') ||
$(this).data('variant-id'),

sku:'',

selling_price:
parent.find('.main-price').text().trim(),

compare_price:
parent.find('.compare-price').text().trim()

};

console.log(currentNotifyData);

$('.notify-popup-wrap').fadeIn(200);

});





document.addEventListener("click", async e => {
  let btn = e.target.closest(".notify-btn-card");
  if (!btn) return;
  let id = btn.closest(".product-grid-item")
    ?.querySelector(".wz-swatches option:checked")
    ?.dataset.variationid || btn.dataset.variantId;
  if (!id) return;
  try {
    let variant = await fetch(`/variants/${id}.js`)
      .then(r => r.json());
    currentNotifyData.sku = variant.sku || '';
    console.log(currentNotifyData.sku);
  } catch(error) {
    console.log(error);
  }
});